// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3XjYj","label":"Category_label__14hk9","content":"Category_content__J0XW9","header":"Category_header__3lJZJ","location":"Category_location__yTLwv"};